import { store } from "Store/mainStore";
import DATAMART_API from "./datamart";
import _, { get } from "lodash";
import { IOfferProps } from "dot/features/dashboard/types";
import { OFFER_STTATUS } from "dot/features/dashboard/utils/constants";
import { formatDate } from "dot/features/dashboard/utils/commonUtils";
import { getUIJsonState } from "./common";
import OOT from "./oot";

class DatamartServices {
  /** saveCartDetails 
   * @param {Object} selectors - The selectors object containing the data from the store.
   * @param {number} stepIndex - The index of the current step in the configurator.
   * if step index = 1 then it should be POST method
   * if step index > 1 then it is PUT method
  */
  saveCartDetails_service = async (selectors, aftersyncoffer_data?) => {
    const sid = selectors?.dynamicSelector?.data?.sid;
    let cartDataList = {
      "offer_id": sid,
      "temp_offer_id": sid,
      "cart_total": selectors?.caseSelector?.data?.total_boq_price ? selectors?.caseSelector?.data?.total_boq_price : 0,
      "summary_total_list_price": selectors?.caseSelector?.data?.total_boq_price ? selectors?.caseSelector?.data?.total_boq_price : 0,
      "status": "draft",
      "source": "cui",
      "assumptions": selectors?.dynamicSelector.data?.element?.["assumptions"]?.["markup"],
      "owner_email": selectors?.authSelector?.offer_owner_email?.length > 0 ? selectors?.authSelector?.offer_owner_email : selectors?.authSelector?.login?.mail
    };
    const caseDetails = this.getCaseDetails(selectors);
    const businessDetails = this.getBusinessDetails(selectors);
    cartDataList = { ...cartDataList, ...caseDetails, ...businessDetails };


    // Get the UI JSON state and add it to the cartDataList
    const uiJsonObject = getUIJsonState(aftersyncoffer_data?.offerid);
    cartDataList['ui_json'] = JSON.stringify(uiJsonObject);

    // decide the method to use for api /offer depending on the redux state
    let method = 'post';

    if (selectors?.dynamicSelector?.data?.save_cart_method === 'put') {
      method = 'put';
      cartDataList.offer_id = uiJsonObject?.["dynamic"]?.['data']?.['offer_id'] ? uiJsonObject?.["dynamic"]?.['data']?.['offer_id'] : sid;
    }

    // if syncoffer call is there then set method to POST and set the offer_id to recieved offerid, send payload to insert into column
    if (aftersyncoffer_data) {
      method = 'post';
      cartDataList.offer_id = aftersyncoffer_data.offerid;
      // dont set temp_offer_id in this case as its a new offer created, already sid is taken from above so that only will be used , both should be different for creating new offer and archiving old one

      // and if in case sid is empty then set tempofferid as offer id, but this should be true anytime. If its happening something is wrong
      // if(sid === "") {
      //   cartDataList.temp_offer_id = aftersyncoffer_data.offerid;
      // }
      if (aftersyncoffer_data?.leadProduct) {
        cartDataList["lead_product"] = aftersyncoffer_data.leadProduct;
      }
      if(aftersyncoffer_data?.payload) {
        cartDataList['sync_offer_payload'] = aftersyncoffer_data.payload;
      }
      if(aftersyncoffer_data?.payload?.offer?.requested_state) {
        cartDataList['status'] = aftersyncoffer_data.payload.offer.requested_state;
      } else if(aftersyncoffer_data?.offer_id) {
        cartDataList['status'] = 'draft';
      }
      cartDataList['profitabilityDelete'] = aftersyncoffer_data.profitabilityDelete === true;
    }
    const res = await DATAMART_API.saveCartDetails(cartDataList, method);
    return res;
  }

  /**
   * Extracts case-related details from the provided selectors.
   * 
   * @param {Object} selectors - The selectors object containing data from the Redux store.
   * @returns {Object} An object containing case-related details such as market, country, case type, and more.
   */
  getCaseDetails = (selectors) => {
    const caseSelector = selectors?.caseSelector;
    const findSelector = selectors?.findSelector;
    const cartSummary = {
      market: caseSelector?.data?.market,
      network_location: caseSelector?.data?.country,
      sub_type: findSelector?.data?.subType,
      summary: caseSelector?.data?.summary,
      case_name: caseSelector?.data?.caseName,
      case_type: findSelector?.data?.caseType,
      co_owners: caseSelector?.data?.co_owner,
      reseller_accountnumber: caseSelector?.data?.resellers,
      opportunity_id: findSelector?.data?.sCRMID ? findSelector?.data?.sCRMID : "19.XY.123456",
      network_id: caseSelector?.data?.network_id,
      end_customer_accountnumber: caseSelector?.data?.endCustomer,
      is_budgetary: _.toLower(caseSelector?.data?.caseCategory) === 'budgetary' ? 'yes' : 'no',
      sales_channel: caseSelector?.data?.sales_channel,
      shipping_country: caseSelector?.data?.shipping_country,
      indirect_reseller: caseSelector?.data?.indirect_resellers,
      public_funding_required: caseSelector?.data?.public_funding_required ? 'yes' : 'no',
      name: caseSelector?.data?.account_name,
      currency: caseSelector?.data?.currency,
      oot_sell_to_party_nid: caseSelector.data?.endCustomer_account_nid,
      sell_to_party_three_star_accountnumber: caseSelector.data?.three_star_number,// got from account api 3* number
      sell_to_party_accountnumber: caseSelector.data?.account_one_star_number, // got from account api 1* number
      // "distributor": "", => TBD ? 
      // end_customer_three_star_accountnumber
      bulk_order: caseSelector?.data?.bulkorder === 'Yes' ? true : false,
      no_of_networks: caseSelector?.data?.bulkorder ? caseSelector?.data?.bulkOrderQuantity : null,
      oot_redirect_reason: caseSelector.data?.oot_redirect_reason,
      oot_redirect_description: caseSelector.data?.oot_redirect_description,
      network_details: caseSelector?.data?.network_details ? caseSelector?.data?.network_details : ""

    };
    return cartSummary;
  }

  /**
   * Extracts business-related details from the provided selectors.
   * 
   * @param {Object} selectors - The selectors object containing data from the Redux store.
   * @returns {Object} An object containing business-related details such as commercial model, contract duration, segment, and solution.
   */
  getBusinessDetails = (selectors) => {
    const dynamicSelector = selectors?.dynamicSelector;
    const caseSelector = selectors?.caseSelector;
    const configStepperSelector = selectors?.configStepperSelector;

    const businessDetails = {
      commercial_model: dynamicSelector?.data?.reference_solution?.commercial_model ? dynamicSelector?.data?.reference_solution?.commercial_model : caseSelector?.data?.commercial_model,
      duration: dynamicSelector?.data?.reference_solution?.contract_duration ? dynamicSelector?.data?.reference_solution?.contract_duration : caseSelector?.data?.contract_duration,
      segment: configStepperSelector?.data?.solutionCategory,  // store solution type eg: ndac,mpw
      solution: configStepperSelector?.data?.solution_selected  // store segment name eg: "pwml"
    };
    return businessDetails;
  }

  /**
   * Fetches offer data based on the provided parameters.
   * Delegates the request to specific methods depending on the offer type (e.g., "DOTOffers").
   * 
   * @param {Object} data - The filter criteria for fetching offers, including offer type and other parameters.
   * @returns {Promise<Object>} A promise that resolves to the fetched offer data.
   */
  fetchOfferData_service = async (data) => {
    // Proceess data based on offerType
    if (data?.offerType === "DOTOffers") {
      return await this.fetchDOTOffers(data);
    }
  };

  /**
   * Fetches DOT offers based on the provided filter criteria, including sorting, search terms, and offer status.
   * Processes the data to convert it into a UI-friendly format.
   *
   * @param {Object} data - The filter criteria for fetching DOT offers, including sort, search, and offerStatus.
   * @returns {Promise<IOfferProps[]>} A promise that resolves to an array of offers formatted for the UI.
   */
  fetchDOTOffers = async (data, actionType = undefined) => {
    // order by processing depending on what user has selected convert to backend format
    let sortByParam = this.sortByQuery(data.sort);
    let dotFilters = actionType && actionType === 'list_favourites' ? this.getAllFilters(data, "dot", "count") : this.getAllFilters(data, "dot", "offers");
    const offerDashboardProperties = this.getOfferDashboardProperties();

    // Prepare API payload
    const cartFilter = {
      properties: offerDashboardProperties,
      offer_id: [],
      limit: data.limit,
      offset: data.offset,
      filter: dotFilters,
      orderBy: sortByParam,
      actionType
    };
    const cartDOTOffers = await DATAMART_API.fetchOffer(cartFilter);
    // if offer is not fetched and the status is false then return empty object
    if (cartDOTOffers.status === false) {
      return {};
    }

    const dotOfferData = cartDOTOffers.data ? cartDOTOffers.data : [];
    // Get the formtted resposne for the UI
    const ui_format_offerData = this.convertResponseToUIFormat(dotOfferData);
    if (actionType && actionType === 'list_favourites') {
      return { data: ui_format_offerData, total_count: cartDOTOffers?.total_count ? cartDOTOffers?.total_count : 0 };
    }
    return ui_format_offerData;
  };

  getAllFilters = (data, type, apiFor) => {
    let dotFilters = `source = 'cui'`;
    // Add filter for my cases - selected status
    if (apiFor === 'offers' && data?.caseType === 'my_cases') {
      dotFilters += `and status = '${data.offerStatus}'`;
    }
    // Add filter for all cases - All statuses
    if (apiFor === 'offers' && data?.caseType === 'all_cases') {
      dotFilters += `and offer.status IN (${OFFER_STTATUS.map(status => `'${status.id}'`).join(',')})`;
    }

    dotFilters += `and (order_deleted != '1' OR order_deleted IS NULL) and (status != 'archived' OR status != 'expired')`;

    // Handle the Search term here
    if (data?.search && data?.search.length > 0) {
      const searchFilter = this.getOfferSearchFilter(data?.search, type);
      if (searchFilter && searchFilter.length > 0) {
        // --- Issue in datamart - query inside () is not working
        // dotFilters += ` and (${searchFilter})`;
        dotFilters += ` AND ${searchFilter}`;
      }
    }
    return dotFilters;
  }

  getOfferDashboardProperties() {
    const offerDashboardProperties = [
      "offer_id",
      'temp_offer_id',
      'sub_type',
      "opportunity_id",
      'lead_product',
      "name",
      "cart_total",
      "duration",
      "co_owners",
      "source",
      "status",
      "createdAt",
      "offer_expiry_date",
      "owner_email",
      "case_name",
      "offer_created_date",
      "sell_to_party_name",
      "currency",
      "summary",
      "sell_to_party_accountnumber",
      'assumptions',
      'sales_channel',
      'case_type',
      'shipping_country',
      'market',
      'is_budgetary',
      'owner_email',
      'network_location',
      'bulk_order',
      'no_of_networks',
      'network_details',
      'sell_to_party_three_star_accountnumber',
      'commercial_model'
    ];

    return offerDashboardProperties;
  }

  convertResponseToUIFormat(responseArray): IOfferProps[] {
    // left hand side is name used in code to display on UI , right hand side are the database mapping name got in response
    return responseArray.map((item) => ({
      offer_id: item.offer_id,
      temp_offer_id: item.temp_offer_id,
      sCRMID: item.opportunity_id,
      // createdAt: item.createdAt,
      subType: item.sub_type,
      source: item.source,
      createdAt: formatDate(item.createdAt),
      caseName: item.case_name,
      account_name: item.sell_to_party_name,
      owner: item.owner_email,
      co_owner: item.co_owners,
      summary: item.summary,
      totalPrice: item.cart_total,
      duration: item.duration,
      currency: item.currency,
      offerAgeInDays: item.createdAt ? Math.floor((Date.now() - new Date(item.createdAt).getTime()) / (1000 * 60 * 60 * 24)) : 0,
      offerStatus: item.status,
      lead_product: item.lead_product,
      is_submitted: item.is_submitted,
      is_bookmarked: item.is_bookmarked ?? false, // Default to false if undefined
      sell_to_party_accountnumber: item.sell_to_party_accountnumber,
      sell_to_party_three_star_accountnumber: item.sell_to_party_three_star_accountnumber,
      assumptions: item.assumptions,
      sales_channel: item.sales_channel,
      caseType: item.case_type,
      shipping_country: item.shipping_country,
      market: item.market,
      is_budgetary: item.is_budgetary,
      owner_email: item.owner_email,
      network_location: item.network_location,
      ui_json: item.ui_json,
      bulk_order: item.bulk_order ? "Yes" : "No",
      no_of_networks: item.no_of_networks ? item.no_of_networks : 1,
      network_details: item.network_details ? item.network_details : "",
      commercial_model: item.commercial_model
    }));
  };


  /**
   * Generates a search filter for offers based on the provided search keyword and type.
   *
   * @param {string} searchKeyword - The keyword to search for in the offers.
   * @param {string} searchType - The type of search to perform (e.g., "caseName", "account_name").
   * @returns {string} The generated search filter.
   */
  getOfferSearchFilter(searchKeyword, searchType) {
    let searchFilter;
    // Convert searchKeyword to lowercase
    searchKeyword = searchKeyword.toLowerCase();
    if (searchType === 'dot') {
      // 1) Prepare search filter for Cart table - account name, case name, sCRMID
      searchFilter = `(LOWER(offer.opportunity_id) like '${searchKeyword}%' or LOWER(offer.name) like '%${searchKeyword}%' or LOWER(offer.case_name) like '%${searchKeyword}%' or LOWER(offer.offer_id) like '%${searchKeyword}%')`;
    }
    if (searchType === 'oot') {
      // 2) Prepare search filter for offer_header_data
      // TODO: Need to check the field name in offer_header_data
    }
    return searchFilter;
  }

  /**
   * Generates a sorting query parameter based on the provided sort criteria.
   * Converts frontend sort keys into backend-compatible query strings.
   * 
   * @param {string} sort - The sort criteria (e.g., '-total_boq_price', 'createdAt').
   * @returns {string} - The backend-compatible sorting query string.
   */
  sortByQuery = (sort) => {
    let sortByParam = '';
    if (sort && sort.length > 0) {
      switch (true) {
        case _.includes(sort, 'total_boq_price'): sortByParam = (sort === '-total_boq_price') ? 'cart_total desc' : (sort === 'total_boq_price') ? 'cart_total asc' : '';
          break;
        case _.includes(sort, 'createdAt'): sortByParam = (sort === '-createdAt') ? 'createdAt desc' : (sort === 'createdAt') ? 'createdAt asc' : '';
          break;
        default: sortByParam = '';
      }
    }
    return sortByParam;
  }

  /**
   * Fetches the count of offers for each status.
   * Generates mock data for offer status counts or prepares a filter for fetching real data.
   * 
   * @param {Object} data - The filter criteria for fetching offer status counts.
   * @returns {Promise<Object>} A promise that resolves to an object containing offer status counts.
   */
  fetchOfferStatusCount = async (data) => {
    // Prepare the list of offer status
    const offerStatusIds = OFFER_STTATUS.map((status) => status.id);

    const quotedOfferStatusIds = offerStatusIds.map((status) => `'${status}'`);
    let countFilter = `status IN (${quotedOfferStatusIds.join(",")})`;
    if (data?.offerType === "DOTOffers") {
      let dotFilters = this.getAllFilters(data, "dot", "counts");
      countFilter += " AND " + dotFilters;
    }
    const statusFilter = {
      properties: {
        "type": "bar",
        "xaxis": "status",
        "yaxis": "count(offer_id)",
        "xaxis_alias": "offer_status",
        "yaxis_alias": "offers_count"
      },
      limit: 100,
      offset: 0,
      filter: countFilter,
    };

    const statusCountResp = await DATAMART_API.fetchOfferStatusCount(statusFilter);
    const statusCount = {}
    if (statusCountResp.data && statusCountResp.data.length > 0) {
      // Prepare latest status count
      OFFER_STTATUS.forEach((status) => {
        // Find the index of the status.id in statusCountResp.data
        const statusCountIndex = statusCountResp.data.findIndex(statusCount => statusCount.offer_status === status.id);
        statusCount[status.id] = statusCountIndex >= 0 ? statusCountResp.data[statusCountIndex]?.offers_count : 0;
      });
    }
    return statusCount;
  }

  /**
   * Fetches both offer data and the count of offers for each status concurrently.
   * Combines the results of `fetchOfferData_service` and `fetchOfferStatusCount` into a single response.
   * 
   * @param {Object} dasboardParam - The filter criteria for fetching offers and status counts.
   * @returns {Promise<Object>} A promise that resolves to an object containing both offer data and status counts.
   */
  fetchOfferDataAndStatusCount = async (dasboardParam) => {
    const [offerData, statusCount] = await Promise.all([
      this.fetchOfferData_service(dasboardParam),
      this.fetchOfferStatusCount(dasboardParam)
    ]);
    return { offerData, statusCount };
  };


  /**
   * Retrieves the saved UI state for a specific offer by its ID.
   *
   * @param offer_id - The unique identifier of the offer.
   * @returns A promise that resolves to the UI state object (`ui_json`) if found,
   *          or an empty object if the offer is not fetched or the status is false.
   */
  getSavedUiState = async (offer_id, temp_offer_id?) => {
    const offerDashboardProperties = ['offer_id', 'temp_offer_id', 'assumptions', 'ui_json', 'co_owners', 'summary'];
    let offerFilter = `offer_id = '${offer_id}'`;
    temp_offer_id && (offerFilter += ` AND temp_offer_id = '${temp_offer_id}'`);
    // Prepare API payload
    const cartFilter = {
      properties: offerDashboardProperties,
      offer_id: [],
      filter: offerFilter,
    };
    const datamartResp = await DATAMART_API.fetchOffer(cartFilter);
    // if offer is not fetched and the status is false then return empty object
    if (datamartResp.status === false) {
      return {};
    }
    let uiJsonResponse = datamartResp?.data ? datamartResp.data[0] : {};
    let co_owners = datamartResp?.data ? datamartResp?.data[0]?.co_owners : "";
    let summary = datamartResp?.data ? datamartResp?.data[0]?.summary : "";
    // Preapr ui_json object
    let uiJson = uiJsonResponse?.ui_json ? uiJsonResponse.ui_json : {};
    // Preapre assumptions object
    const assumptions = uiJsonResponse?.assumptions || "";
    // Handle the updated assumptions if they are present and add them to the ui_json
    const convertedUIJson = typeof uiJson === "string" ? JSON.parse(uiJson) : uiJson;
    // Check for the dynamic selector data
    if (convertedUIJson?.dynamic?.data) {
      // Update the assumptions in the dynamic data
      if (convertedUIJson && convertedUIJson.dynamic && convertedUIJson.dynamic.data) {
        convertedUIJson.dynamic.data['assumptions'] = assumptions;

        // Ensure the element object exists
        if (convertedUIJson?.dynamic?.data?.element) {

          // Update or create the assumptions object with markup
          if (convertedUIJson.dynamic.data.element?.['assumptions']?.['markup']) {
            convertedUIJson.dynamic.data.element['assumptions'].markup = assumptions;
          } else if (convertedUIJson.dynamic.data.element?.['assumptions']) {
            convertedUIJson.dynamic.data.element['assumptions'] = { ...convertedUIJson.dynamic.data.element['assumptions'], markup: assumptions };
          }
        }
        uiJson = JSON.stringify(convertedUIJson);
      }
    }
    // Set the co_owners to ui_json
    if (convertedUIJson?.caseDetails && convertedUIJson?.caseDetails?.data) {
      convertedUIJson.caseDetails.data['co_owner'] = co_owners;
      convertedUIJson.caseDetails.data['summary'] = summary;
      uiJson = JSON.stringify(convertedUIJson);
    }
    // Return the formtted resposne for the UI
    return uiJson;
  };


  updateOfferProperties = async (offerProperties) => {
    // Save the offer properties to the Datamart API
    const modifiedOfferProperties = _.cloneDeep(offerProperties);
    delete modifiedOfferProperties['co_owner'];
    const datamartResp = await DATAMART_API.editProperties(modifiedOfferProperties);
    let respData = datamartResp[0] ? datamartResp[0] : datamartResp;
    // Check if the response is successful
    if (!respData || _.isEmpty(respData)) {
      respData = {
        status: false,
        message: "Error in updating offer to datamart, try again.",
      }
      return respData;
    }
    // Check for submitted offer
    const isSubmitted = offerProperties?.temp_offer_id === offerProperties?.offer_id ? false : true;
    // Check if the response is successful
    if (respData && respData?.status === true && isSubmitted) {
      // Update the offer properties in OOT syncOffer
      const offerList = {
        offer: {
          id: offerProperties?.offer_id,
          name: offerProperties?.caseName,
          sales_channel: offerProperties?.sales_channel,
          summary: offerProperties?.summary,
          co_owner: offerProperties?.co_owner,
          scrm_id: offerProperties?.sCRMID,
          case_type: offerProperties?.caseType,
          case_sub_type: offerProperties?.subType,
          lead_product: offerProperties?.lead_product,
          shipping_country: offerProperties?.shipping_country,
          market: offerProperties?.market,
          budgetary: offerProperties?.is_budgetary === 'yes' ? 'budgetary' : 'binding',
          owner: offerProperties?.owner_email,
          network_location: offerProperties?.network_location,
          update_only: "basic_details", //  send a flag to oot to update only basic properties and not empty the line items
          bulk_order: offerProperties?.bulk_order,
          no_of_networks: offerProperties?.no_of_networks,
          network_details: offerProperties?.network_details
        },
        assumptions: offerProperties?.assumptions,
      };
      // offer payload is sent to DOT backend and update the offer in OOT
      const syncOfferResponse = await OOT.syncOffer({
        data: offerList,
      });

      // Handle error response
      if (syncOfferResponse?.status === false) {
        respData = {
          status: false,
          errorCode: syncOfferResponse?.errorCode,
          errorMessage: syncOfferResponse?.errorMessage,
          datamartResponse: datamartResp,
          syncOfferResposne: syncOfferResponse,
        }
        return respData;
      }
      // Handle success response
      respData = {
        status: true,
        message: "Offer updated successfully!",
        datamartResponse: datamartResp,
        syncOfferResposne: syncOfferResponse,
      }
    }
    return respData;
  };


  /**
   * Fetches the user's favorite offers based on the provided filter object.
   *
   * @param offerFilterObj - The filter criteria for retrieving favorite offers.
   * @returns A promise resolving to the list of favorite offers.
   */
  fetchUserFavoritesOffer = async (offerFilterObj) => {
    const favResp = await this.fetchDOTOffers(offerFilterObj, 'list_favourites');
    return favResp;
  }

  getOfferDetails = async (offerInputs) => {
    const offerDashboardProperties = this.getOfferDashboardProperties();
    offerDashboardProperties.push(
      'ui_json',
      'sync_offer_payload',
      'end_customer_accountnumber',
      'reseller_accountnumber',
      'network_id',
      'indirect_reseller',
      'public_funding_required',
      'oot_sell_to_party_nid',
      'sell_to_party_three_star_accountnumber',
      'commercial_model',
      'duration',
      'segment',
      'solution'
    );
    // Prepare API payload
    const cartFilter = {
      properties: offerDashboardProperties,
      filter: `offer_id = '${offerInputs.offer_id}' AND temp_offer_id = '${offerInputs.temp_offer_id}'`
    };
    const offerDetails = await DATAMART_API.fetchOffer(cartFilter);
    // if offer is not fetched and the status is false then return empty object
    if (offerDetails.status === false) {
      return {};
    }
    return offerDetails;
  }

  handleDuplicateOffer = async (offerDataToChange) => {
    // call api to insert offer with offerDataToChange as payload
    const res = await DATAMART_API.saveCartDetails(offerDataToChange, 'post');
    return res;
  }


  /**
   * Retrieves offer details by offer ID or temporary offer ID.
   *
   * @param offerId - The unique identifier of the offer to fetch.
   * @returns A promise that resolves to the formatted offer data for the UI, or an empty object if not found.
   */
  getOfferById = async (offerId) => {
    // order by processing depending on what user has selected convert to backend format
    let sortByParam = this.sortByQuery([]);
    let dotFilters = this.getAllFilters({}, "dot", "offers");
    const offerDashboardProperties = [
      "offer_id",
      "source",
      "sub_type",
      'temp_offer_id',
      "status",
      'lead_product',
      'owner_email',
      'co_owners',
      'bulk_order',
      'no_of_networks',
      'network_details'
    ]

    // Prepare API payload
    const cartFilter = {
      properties: offerDashboardProperties,
      offer_id: [],
      limit: 1,
      offset: 0,
      filter: `${dotFilters} AND (offer_id = '${offerId}' OR temp_offer_id = '${offerId}')`,
      orderBy: sortByParam,
    };

    const fetchoffer_api_details = {
      method: "post",
      url: `/v2/offer`,
      data: cartFilter,
      operation: 'read'
    };
    const cartDOTOffers = await DATAMART_API.genericDatamartAPI(fetchoffer_api_details);
    // if offer is not fetched and the status is false then return empty object
    if (cartDOTOffers.status === false) {
      return {};
    }

    const dotOfferData = cartDOTOffers.data ? cartDOTOffers.data : [];
    // Get the formtted resposne for the UI
    const ui_format_offerData = this.convertResponseToUIFormat(dotOfferData);
    return ui_format_offerData;
  };
}
const DATAMART_SERVICES = new DatamartServices();
export default DATAMART_SERVICES;